// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fWPdD","comment":"styles_comment__xQDS3"};